//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TenantClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type TenantGetTenantQueryParameters = {
  id: string ;
}

export type TenantUpdateTenantQueryParameters = {
  id: string ;
}

export type TenantDeleteTenantQueryParameters = {
  id: string ;
}

export type TenantGetListTenantQueryParameters = {
  filter?: string | undefined ;
  sorting?: string | undefined ;
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
}

export type TenantGetDefaultConnectionStringTenantQueryParameters = {
  id: string ;
}

export type TenantUpdateDefaultConnectionStringTenantQueryParameters = {
  id: string ;
  defaultConnectionString?: string | undefined ;
}

export type TenantDeleteDefaultConnectionStringTenantQueryParameters = {
  id: string ;
}

export function tenantGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let tenantGetDefaultOptions: Omit<UseQueryOptions<Types.TenantDto, unknown, Types.TenantDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TenantDto, unknown, Types.TenantDto>, 'queryFn'>> = {
};
export function getTenantGetDefaultOptions() {
  return tenantGetDefaultOptions;
};
export function setTenantGetDefaultOptions(options: typeof tenantGetDefaultOptions) {
  tenantGetDefaultOptions = options;
}

export function tenantGetQueryKey(id: string): QueryKey;
export function tenantGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as TenantGetTenantQueryParameters;

    return trimArrayEnd([
        'TenantClient',
        'tenantGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'TenantClient',
        'tenantGet',
        ...params
      ]);
  }
}
export function __tenantGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.tenantGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useTenantGetQuery<TSelectData = Types.TenantDto, TError = unknown>(dto: TenantGetTenantQueryParameters, options?: Omit<UseQueryOptions<Types.TenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useTenantGetQuery<TSelectData = Types.TenantDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.TenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTenantGetQuery<TSelectData = Types.TenantDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TenantDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as TenantGetTenantQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TenantDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __tenantGet(context, axiosConfig) : __tenantGet,
    queryKey: tenantGetQueryKey(id),
    ...tenantGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.TenantDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setTenantGetData(queryClient: QueryClient, updater: (data: Types.TenantDto | undefined) => Types.TenantDto, id: string) {
  queryClient.setQueryData(tenantGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setTenantGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TenantDto | undefined) => Types.TenantDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function tenantUpdateUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function tenantUpdateMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'tenantUpdate',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useTenantUpdateMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.TenantDto, unknown, Types.TenantUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TenantDto, unknown, Types.TenantUpdateDto, TContext> {
  const key = tenantUpdateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.TenantUpdateDto) => Client.tenantUpdate(id, body),
    mutationKey: key,
  });
}
  
type TenantUpdate__MutationParameters = TenantUpdateTenantQueryParameters & {
  body: Types.TenantUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useTenantUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.TenantDto, unknown, TenantUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TenantUpdateTenantQueryParameters}): UseMutationResult<Types.TenantDto, unknown, TenantUpdate__MutationParameters, TContext> {
  const key = tenantUpdateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TenantUpdate__MutationParameters) => Client.tenantUpdate(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function tenantDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function tenantDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'tenantDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useTenantDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = tenantDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.tenantDelete(id),
    mutationKey: key,
  });
}
  
type TenantDelete__MutationParameters = TenantDeleteTenantQueryParameters

/**
 * @return OK
 */
export function useTenantDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, TenantDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TenantDeleteTenantQueryParameters}): UseMutationResult<void, unknown, TenantDelete__MutationParameters, TContext> {
  const key = tenantDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TenantDelete__MutationParameters) => Client.tenantDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function tenantGetListUrl(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants?";
if (filter === null)
    throw new Error("The parameter 'filter' cannot be null.");
else if (filter !== undefined)
    url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
if (sorting === null)
    throw new Error("The parameter 'sorting' cannot be null.");
else if (sorting !== undefined)
    url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let tenantGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfTenantDto, unknown, Types.PagedResultDtoOfTenantDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfTenantDto, unknown, Types.PagedResultDtoOfTenantDto>, 'queryFn'>> = {
};
export function getTenantGetListDefaultOptions() {
  return tenantGetListDefaultOptions;
};
export function setTenantGetListDefaultOptions(options: typeof tenantGetListDefaultOptions) {
  tenantGetListDefaultOptions = options;
}

export function tenantGetListQueryKey(dto: TenantGetListTenantQueryParameters): QueryKey;
export function tenantGetListQueryKey(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): QueryKey;
export function tenantGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { filter, sorting, skipCount, maxResultCount,  } = params[0] as TenantGetListTenantQueryParameters;

    return trimArrayEnd([
        'TenantClient',
        'tenantGetList',
        filter as any,
        sorting as any,
        skipCount as any,
        maxResultCount as any,
      ]);
  } else {
    return trimArrayEnd([
        'TenantClient',
        'tenantGetList',
        ...params
      ]);
  }
}
export function __tenantGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.tenantGetList(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as number | undefined,axiosConfig    );
}

export function useTenantGetListQuery<TSelectData = Types.PagedResultDtoOfTenantDto, TError = unknown>(dto: TenantGetListTenantQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfTenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function useTenantGetListQuery<TSelectData = Types.PagedResultDtoOfTenantDto, TError = unknown>(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfTenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTenantGetListQuery<TSelectData = Types.PagedResultDtoOfTenantDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfTenantDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let filter: any = undefined;
  let sorting: any = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ filter, sorting, skipCount, maxResultCount,  } = params[0] as TenantGetListTenantQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [filter, sorting, skipCount, maxResultCount, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfTenantDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __tenantGetList(context, axiosConfig) : __tenantGetList,
    queryKey: tenantGetListQueryKey(filter, sorting, skipCount, maxResultCount),
    ...tenantGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfTenantDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setTenantGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfTenantDto | undefined) => Types.PagedResultDtoOfTenantDto, filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined) {
  queryClient.setQueryData(tenantGetListQueryKey(filter, sorting, skipCount, maxResultCount),
    updater
  );
}

/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setTenantGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfTenantDto | undefined) => Types.PagedResultDtoOfTenantDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function tenantCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function tenantCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'tenantCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useTenantCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.TenantDto, unknown, Types.TenantCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TenantDto, unknown, Types.TenantCreateDto, TContext> {
  const key = tenantCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.TenantCreateDto) => Client.tenantCreate(body),
    mutationKey: key,
  });
}
  
export function tenantGetDefaultConnectionStringUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants/{id}/default-connection-string";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let tenantGetDefaultConnectionStringDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getTenantGetDefaultConnectionStringDefaultOptions() {
  return tenantGetDefaultConnectionStringDefaultOptions;
};
export function setTenantGetDefaultConnectionStringDefaultOptions(options: typeof tenantGetDefaultConnectionStringDefaultOptions) {
  tenantGetDefaultConnectionStringDefaultOptions = options;
}

export function tenantGetDefaultConnectionStringQueryKey(id: string): QueryKey;
export function tenantGetDefaultConnectionStringQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as TenantGetDefaultConnectionStringTenantQueryParameters;

    return trimArrayEnd([
        'TenantClient',
        'tenantGetDefaultConnectionString',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'TenantClient',
        'tenantGetDefaultConnectionString',
        ...params
      ]);
  }
}
export function __tenantGetDefaultConnectionString(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.tenantGetDefaultConnectionString(
      context.queryKey[2] as string,axiosConfig    );
}

export function useTenantGetDefaultConnectionStringQuery<TSelectData = string, TError = unknown>(dto: TenantGetDefaultConnectionStringTenantQueryParameters, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useTenantGetDefaultConnectionStringQuery<TSelectData = string, TError = unknown>(id: string, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTenantGetDefaultConnectionStringQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as TenantGetDefaultConnectionStringTenantQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __tenantGetDefaultConnectionString(context, axiosConfig) : __tenantGetDefaultConnectionString,
    queryKey: tenantGetDefaultConnectionStringQueryKey(id),
    ...tenantGetDefaultConnectionStringDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setTenantGetDefaultConnectionStringData(queryClient: QueryClient, updater: (data: string | undefined) => string, id: string) {
  queryClient.setQueryData(tenantGetDefaultConnectionStringQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setTenantGetDefaultConnectionStringDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function tenantUpdateDefaultConnectionStringUrl(id: string, defaultConnectionString?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants/{id}/default-connection-string?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (defaultConnectionString === null)
    throw new Error("The parameter 'defaultConnectionString' cannot be null.");
else if (defaultConnectionString !== undefined)
    url_ += "defaultConnectionString=" + encodeURIComponent("" + defaultConnectionString) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function tenantUpdateDefaultConnectionStringMutationKey(id: string, defaultConnectionString?: string | undefined): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'tenantUpdateDefaultConnectionString',
      id as any,
      defaultConnectionString as any,
    ]);
}

/**
 * @param defaultConnectionString (optional) 
 * @return OK
 */
export function useTenantUpdateDefaultConnectionStringMutation<TContext>(id: string, defaultConnectionString?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = tenantUpdateDefaultConnectionStringMutationKey(id, defaultConnectionString);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.tenantUpdateDefaultConnectionString(id, defaultConnectionString),
    mutationKey: key,
  });
}
  
type TenantUpdateDefaultConnectionString__MutationParameters = TenantUpdateDefaultConnectionStringTenantQueryParameters

/**
 * @param defaultConnectionString (optional) 
 * @return OK
 */
export function useTenantUpdateDefaultConnectionStringMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, TenantUpdateDefaultConnectionString__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TenantUpdateDefaultConnectionStringTenantQueryParameters}): UseMutationResult<void, unknown, TenantUpdateDefaultConnectionString__MutationParameters, TContext> {
  const key = tenantUpdateDefaultConnectionStringMutationKey(options?.parameters?.id!, options?.parameters?.defaultConnectionString!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TenantUpdateDefaultConnectionString__MutationParameters) => Client.tenantUpdateDefaultConnectionString(data.id ?? options?.parameters?.id!, data.defaultConnectionString ?? options?.parameters?.defaultConnectionString!),
  mutationKey: key,
});
}
  
export function tenantDeleteDefaultConnectionStringUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/multi-tenancy/tenants/{id}/default-connection-string";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function tenantDeleteDefaultConnectionStringMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'tenantDeleteDefaultConnectionString',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useTenantDeleteDefaultConnectionStringMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = tenantDeleteDefaultConnectionStringMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.tenantDeleteDefaultConnectionString(id),
    mutationKey: key,
  });
}
  
type TenantDeleteDefaultConnectionString__MutationParameters = TenantDeleteDefaultConnectionStringTenantQueryParameters

/**
 * @return OK
 */
export function useTenantDeleteDefaultConnectionStringMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, TenantDeleteDefaultConnectionString__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TenantDeleteDefaultConnectionStringTenantQueryParameters}): UseMutationResult<void, unknown, TenantDeleteDefaultConnectionString__MutationParameters, TContext> {
  const key = tenantDeleteDefaultConnectionStringMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TenantDeleteDefaultConnectionString__MutationParameters) => Client.tenantDeleteDefaultConnectionString(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}